module.exports = __webpack_public_path__ + "media/images/can_icon-9327946b21d4ed0262a0c72eb390fe61.svg";